import { ApiEndPoint } from '@/domains/api/api.entity';
import type {
  CharacterizationApiResponse,
  HistorialRiesgosApiResponse,
} from '@/domains/characterization/characterization.entity';
import { apiRequest } from './apiRequest';

/**
 * Implementación de la lógica para llamar al API de caracterizacion
 */
class CharacterizationService {
  async getCharacterization(
    codIncorporacionEstudiante: string,
  ): Promise<CharacterizationApiResponse> {
    const characterizationResponse =
      await apiRequest.get<CharacterizationApiResponse>({
        route: ApiEndPoint.CHARACTERIZATION,
        param: `/${codIncorporacionEstudiante}`,
      });

    return characterizationResponse;
  }

  async getHistorialRiesgos(
    codIncorporacionEstudiante: string,
  ): Promise<HistorialRiesgosApiResponse> {
    const historialResponse = await apiRequest.get<HistorialRiesgosApiResponse>(
      {
        route: ApiEndPoint.CHARACTERIZATION,
        param: `/${codIncorporacionEstudiante}/historial-riesgos`,
      },
    );

    return historialResponse;
  }
}

export const characterizaitonApiService = new CharacterizationService();
